import {StoreStateShape} from '../store/storeStateTypes';

const cesiaCCCIntegrationFeatureSelector = ({commonUserDataReducer: {features}}: StoreStateShape) =>
    features?.CesiaCCCIntegration;

const integrationDispatchFeatureSelector = ({commonUserDataReducer: {features}}: StoreStateShape) =>
    features?.IntegrationDispatch;

const isWSConnectedSelector = ({commonUserDataReducer: {isWSConnected}}: StoreStateShape) => isWSConnected;

const isFfCallBellLogAvailableSelector = ({
    commonUserDataReducer: {
        features: {DisplayMissedCallsLog},
        permissions,
    },
}: StoreStateShape) => ({
    isFfCallBellLogAvailable: DisplayMissedCallsLog,
    permissions,
});

const brightStarIntegrationFeatureSelector = ({commonUserDataReducer: {features}}: StoreStateShape) =>
    features?.BrightStarIntegration;

export {
    brightStarIntegrationFeatureSelector,
    cesiaCCCIntegrationFeatureSelector,
    integrationDispatchFeatureSelector,
    isFfCallBellLogAvailableSelector,
    isWSConnectedSelector,
};
